import { Stack } from "@mui/material";

import { Ambulanzes } from "./components/ambulanzes/Ambulanzes";
import { Appointments } from "./components/appointments/Appointments";
import { Assignments } from "./components/assignments/Assignments";
import { PriorityRequestsWidget } from "./components/priority-requests/PriorityRequestsWidget";

export function Home() {
  return (
    <Stack flex={1} overflow="hidden" flexDirection={{ xs: "column", md: "row" }} gap={3} pb={3}>
      <Stack flex={1} overflow="hidden" gap={3}>
        <Stack flex={1} overflow="hidden">
          <Appointments />
        </Stack>
        <PriorityRequestsWidget />
      </Stack>
      <Stack flex={1} overflow="hidden" gap={3} flexDirection={{ xs: "row", md: "column" }}>
        <Ambulanzes />
        <Assignments />
      </Stack>
    </Stack>
  );
}
